module.exports = __webpack_public_path__ + "img/baseline-wifi-24px.db021153.svg";